import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import regulationImg from "../../img/AboutUs/rec1.webp";
import riskImg from "../../img/AboutUs/rec2.webp";
import Fade from 'react-reveal/Fade';

const mobileTabs = [
  {
    id: "regulation",
    image: regulationImg,
    titleKey: "about.regulation.title",
    textKeys: [
      "about.regulation.text1",
      "about.regulation.text2",
    ],
  },
  {
    id: "risk",
    image: riskImg,
    titleKey: "about.risk.title",
    textKeys: ["about.risk.text1", "about.risk.text2"],
  },
];

function Regulation() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("regulation");
  const activeMobileTab =
    mobileTabs.find((tab) => tab.id === activeTab) || mobileTabs[0];

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[577px] max-w-[1220px]">
          {/* Top-right image */}
          <Fade bottom>
          <div className="absolute left-[625px] top-0 h-[288px] w-[595px] overflow-hidden">
            <img src={regulationImg} alt="" className="h-full w-full object-cover" />
          </div>
          </Fade>
          {/* Bottom-left image */}
          <Fade bottom delay={100}>
          <div className="absolute left-0 top-[289px] h-[288px] w-[625px] overflow-hidden">
            <img src={riskImg} alt="" className="h-full w-full object-cover" />
          </div>

          </Fade>
          {/* Regulation & Compliance text (top-left) */}
          <Fade bottom delay={200}>
          <div className="absolute left-0 top-0 w-[580px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.regulation.title")}
            </h2>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.regulation.text1")}
            </p>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.regulation.text2")}
            </p>
          </div>

          </Fade>
          {/* Risk Disclosure text (bottom-right) */}
          <Fade bottom delay={300}>
          <div className="absolute left-[665px] top-[340px] w-[471px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.risk.title")}
            </h2>
            <p className="mt-[20px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.risk.text1")}
            </p>
            <p className="mt-[15px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
              {t("about.risk.text2")}
            </p>
          </div>
          </Fade>
        </div>
      </div>

      {/* Mobile */}
      <Fade bottom>
      <div className="xl:hidden">
        <div className="overflow-hidden">
          <img
            src={activeMobileTab.image}
            alt=""
            className="h-[185px] w-full object-cover"
          />
        </div>

        <div className="px-[20px] pt-[18px]">
          <div className="flex gap-[10px]">
            {mobileTabs.map((tab) => {
              const isActive = tab.id === activeTab;

              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`inline-flex items-center justify-center gap-[10px] rounded-[30px] px-[18px] py-[4px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a] transition-colors ${
                    isActive
                      ? "bg-[#daebfc]"
                      : "border border-[#05193a] bg-white"
                  }`}
                >
                  {t(tab.titleKey)}
                </button>
              );
            })}
          </div>

          <h2 className="mt-[22px] font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t(activeMobileTab.titleKey)}
          </h2>
          <span className="mt-[10px] block h-[4px] w-[104px] bg-[#05193a]" />
          {activeMobileTab.textKeys.map((textKey, index) => (
            <p
              key={textKey}
              className={`font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a] ${
                index === 0 ? "mt-[20px]" : "mt-[14px]"
              }`}
            >
              {t(textKey)}
            </p>
          ))}
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default Regulation;
